module.exports = __webpack_public_path__ + "static/media/Logo-Partyservice-Schuller.23faf90a.png";